
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/news/stories/[[...pageNumber]]",
      function () {
        return require("private-next-pages/[locale]/news/stories/[[...pageNumber]]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/news/stories/[[...pageNumber]]"])
      });
    }
  